// extracted by mini-css-extract-plugin
export default {"zoomModal":"T2-z"};